import React, { useState, useRef, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import "simplebar/dist/simplebar.min.css";
import Mstatus from "./Mstatus";
import ChartsDashboard from "./ChartsDashboard";
import AreaChart from "./AreaChart";

import { Routes, Route, useNavigate } from "react-router-dom";

import axios from "axios";
import { BASE_URL, security_key } from "../../../global";

const Dashboard = () => {
    const IconStyle = {
        fontSize: "10px",
        fontWeight: "500",
    };

    // const [searchParams] = useSearchParams();
    // const payerID = searchParams.get("PayerID");

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const payerID = queryParams.get("PayerID");

    const [showAddMember, setShowAddMember] = useState(false);

    const handleAddMemberClick = () => {
        setShowAddMember(!showAddMember);
    };

    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("dashboard");
    const [expandedTab, setExpandedTab] = useState("");
    const networkDropdownRef = useRef(null);
    const financeDropdownRef = useRef(null);
    const navigate = useNavigate();

    const [totalDownline, setTotalDownline] = useState(0);
    const [totalEarnings, setTotalEarnings] = useState(0);
    const [referralEarnings, setReferralEarnings] = useState(0);

    useEffect(() => {
        getDashboardStatistics();
    }, []);

    const getDashboardStatistics = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getDashboardStatistics",
                pk_user_key: sessionStorage.getItem("pk_user_key"),
            });

            const output = response.data;
            if (Object.keys(output).length > 0) {
                setTotalDownline(output["totalDownline"]);
                setTotalEarnings(output["totalEarnings"]);
                setReferralEarnings(output["referralEarnings"]);
            } else {
                console.error("Oops! Something went wrong.");
            }
        } catch (error) {
            console.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        navigate(`/${tab}`);
    };

    const handleTabClickE = (tab) => {
        setExpandedTab(expandedTab === tab ? "" : tab);
    };

    const handleTabClickF = (tab) => {
        setExpandedTab(expandedTab === tab ? "" : tab);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (networkDropdownRef.current && !networkDropdownRef.current.contains(event.target)) {
                setExpandedTab((prevTab) => (prevTab === "Network" ? "" : prevTab));
            }
            if (financeDropdownRef.current && !financeDropdownRef.current.contains(event.target)) {
                setExpandedTab((prevTab) => (prevTab === "Finance" ? "" : prevTab));
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleMemberAdded = () => {
        setShowAddMember(false);
        navigate("/downline");
    };

    useEffect(() => {
        if (payerID) {
            sessionStorage.setItem("subscription_status", "yes");
            showPaymentCompletedMessage();
        }
    }, [payerID]);

    const showPaymentCompletedMessage = () => {
        //Swal.fire("Payment Completed!", "Your transaction was successful.", "success");
    };

    return (
        <section className="pb-3  ">
            <main className="main-content">
                <h3 className="page-title">Dashboard</h3>
                <div className="row g-2">
                    <div className="col-md-12 col-lg-4 px-1">
                        <div className="head-box p-3 d-flex">
                            <div className="box">
                                <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="68" height="68" rx="7" fill="white" />
                                    <path
                                        d="M37.3335 15.666C38.2743 15.6658 39.196 15.9311 39.9929 16.4313C40.7897 16.9316 41.4292 17.6464 41.8379 18.4938C42.2466 19.3412 42.408 20.2867 42.3034 21.2217C42.1988 22.1567 41.8326 23.0432 41.2468 23.7793L44.5801 29.1177C44.9324 29.0388 45.2946 28.9993 45.6668 28.9993C46.7993 28.9992 47.8984 29.3835 48.784 30.0894C49.6696 30.7952 50.2894 31.7809 50.5418 32.8849C50.7942 33.9889 50.6644 35.146 50.1735 36.1666C49.6826 37.1872 48.8598 38.0109 47.8397 38.5029C46.8196 38.9949 45.6628 39.126 44.5585 38.8748C43.4542 38.6236 42.4679 38.0049 41.761 37.12C41.0542 36.2352 40.6686 35.1366 40.6676 34.004C40.6665 32.8715 41.05 31.7722 41.7551 30.886L38.4218 25.5477C37.7061 25.707 36.9642 25.707 36.2485 25.5477L32.9135 30.886C33.5935 31.741 34.0001 32.8227 34.0001 33.9993C34.0001 35.176 33.5935 36.2593 32.9118 37.1127L36.2485 42.451C36.5985 42.3721 36.9601 42.3327 37.3335 42.3327C38.466 42.3325 39.565 42.7168 40.4507 43.4227C41.3363 44.1286 41.956 45.1142 42.2085 46.2182C42.4609 47.3223 42.331 48.4793 41.8402 49.4999C41.3493 50.5205 40.5264 51.3442 39.5064 51.8362C38.4863 52.3282 37.3294 52.4593 36.2251 52.2081C35.1208 51.9569 34.1345 51.3382 33.4277 50.4534C32.7208 49.5685 32.3353 48.4699 32.3342 47.3374C32.3332 46.2049 32.7166 45.1055 33.4218 44.2193L30.0835 38.881C29.3689 39.0399 28.6281 39.0399 27.9135 38.881L24.5768 44.2193C25.3114 45.1421 25.6962 46.2949 25.6631 47.4739C25.63 48.6529 25.1811 49.7823 24.3958 50.6623C23.6106 51.5424 22.5395 52.1166 21.3719 52.2833C20.2042 52.45 19.0152 52.1986 18.015 51.5735C17.0148 50.9484 16.2678 49.9898 15.9061 48.8672C15.5443 47.7446 15.591 46.5302 16.038 45.4387C16.485 44.3472 17.3034 43.4488 18.3487 42.9024C19.394 42.356 20.5988 42.1967 21.7501 42.4527L25.0868 37.1127C24.4422 36.3038 24.0643 35.3149 24.0052 34.2823C23.9461 33.2497 24.2086 32.2242 24.7567 31.347C25.3048 30.4699 26.1114 29.7843 27.0654 29.3847C28.0194 28.9851 29.0739 28.8913 30.0835 29.116L33.4201 23.7793C32.8343 23.0432 32.4681 22.1567 32.3636 21.2217C32.259 20.2867 32.4204 19.3412 32.8291 18.4938C33.2378 17.6464 33.8773 16.9316 34.6741 16.4313C35.4709 15.9311 36.3927 15.6658 37.3335 15.666Z"
                                        fill="black"
                                    />
                                </svg>
                            </div>
                            <div className="box px-2 my-auto">
                                <div className="text-box">
                                    <p>Total Downline</p>
                                    <span className="head-box-count">{totalDownline}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-4 px-1">
                        <div className="head-box p-3 d-flex">
                            <div className="box">
                                <svg width="69" height="68" viewBox="0 0 69 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.666992" width="68" height="68" rx="7" fill="white" />
                                    <path
                                        d="M44.2582 37.3335C45.5582 37.3335 46.7032 37.9951 47.3748 39.0001H37.1665C36.0614 39.0001 35.0016 39.4391 34.2202 40.2205C33.4388 41.0019 32.9998 42.0617 32.9998 43.1668V49.8335C32.9998 50.1035 33.0248 50.3657 33.0748 50.6201C28.1765 50.3101 24.5148 48.5368 22.1915 45.2751C21.6378 44.4987 21.3401 43.5688 21.3398 42.6151V41.0818C21.3403 40.0878 21.7353 39.1347 22.4382 38.4318C23.141 37.729 24.0942 37.3339 25.0882 37.3335H44.2582ZM34.6665 17.3418C35.7609 17.3418 36.8445 17.5573 37.8555 17.9761C38.8666 18.3949 39.7852 19.0088 40.5591 19.7826C41.3329 20.5564 41.9467 21.4751 42.3655 22.4861C42.7843 23.4971 42.9998 24.5808 42.9998 25.6751C42.9998 26.7695 42.7843 27.8531 42.3655 28.8642C41.9467 29.8752 41.3329 30.7939 40.5591 31.5677C39.7852 32.3415 38.8666 32.9553 37.8555 33.3741C36.8445 33.7929 35.7609 34.0085 34.6665 34.0085C32.4564 34.0085 30.3368 33.1305 28.774 31.5677C27.2111 30.0049 26.3332 27.8853 26.3332 25.6751C26.3332 23.465 27.2111 21.3454 28.774 19.7826C30.3368 18.2198 32.4564 17.3418 34.6665 17.3418ZM34.6665 43.1668C34.6665 42.5038 34.9299 41.8679 35.3987 41.399C35.8676 40.9302 36.5035 40.6668 37.1665 40.6668H50.4998C51.1629 40.6668 51.7988 40.9302 52.2676 41.399C52.7364 41.8679 52.9998 42.5038 52.9998 43.1668V49.8335C52.9998 50.4965 52.7364 51.1324 52.2676 51.6012C51.7988 52.0701 51.1629 52.3335 50.4998 52.3335H37.1665C36.5035 52.3335 35.8676 52.0701 35.3987 51.6012C34.9299 51.1324 34.6665 50.4965 34.6665 49.8335V43.1668ZM51.3332 44.0001C50.8911 44.0001 50.4672 43.8245 50.1547 43.512C49.8421 43.1994 49.6665 42.7755 49.6665 42.3335H47.9998C47.9998 43.2175 48.351 44.0654 48.9762 44.6905C49.6013 45.3156 50.4491 45.6668 51.3332 45.6668V44.0001ZM51.3332 47.3335C50.4491 47.3335 49.6013 47.6847 48.9762 48.3098C48.351 48.9349 47.9998 49.7827 47.9998 50.6668H49.6665C49.6665 50.2248 49.8421 49.8008 50.1547 49.4883C50.4672 49.1757 50.8911 49.0001 51.3332 49.0001V47.3335ZM37.9998 42.3335C37.9998 42.7755 37.8242 43.1994 37.5117 43.512C37.1991 43.8245 36.7752 44.0001 36.3332 44.0001V45.6668C37.2172 45.6668 38.0651 45.3156 38.6902 44.6905C39.3153 44.0654 39.6665 43.2175 39.6665 42.3335H37.9998ZM39.6665 50.6668C39.6665 49.7827 39.3153 48.9349 38.6902 48.3098C38.0651 47.6847 37.2172 47.3335 36.3332 47.3335V49.0001C36.7752 49.0001 37.1991 49.1757 37.5117 49.4883C37.8242 49.8008 37.9998 50.2248 37.9998 50.6668H39.6665ZM46.7498 46.5001C46.7498 45.7266 46.4426 44.9847 45.8956 44.4377C45.3486 43.8908 44.6067 43.5835 43.8332 43.5835C43.0596 43.5835 42.3178 43.8908 41.7708 44.4377C41.2238 44.9847 40.9165 45.7266 40.9165 46.5001C40.9165 47.2737 41.2238 48.0155 41.7708 48.5625C42.3178 49.1095 43.0596 49.4168 43.8332 49.4168C44.6067 49.4168 45.3486 49.1095 45.8956 48.5625C46.4426 48.0155 46.7498 47.2737 46.7498 46.5001Z"
                                        fill="black"
                                    />
                                </svg>
                            </div>
                            <div className="box px-2 my-auto">
                                <div className="text-box">
                                    <p>Referral Earnings</p>
                                    <span className="head-box-count">${referralEarnings}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-4 px-1">
                        <div className="head-box p-3 d-flex">
                            <div className="box">
                                <svg width="69" height="68" viewBox="0 0 69 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.333008" width="68" height="68" rx="7" fill="white" />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M48.3493 30.4332C48.2521 30.4285 48.1549 30.4268 48.0576 30.4282H43.9993C40.6793 30.4282 37.8359 33.0632 37.8359 36.4999C37.8359 39.9365 40.6793 42.5715 44.0009 42.5715H48.0559C48.1576 42.5715 48.2559 42.5715 48.3476 42.5649C49.0329 42.5211 49.6789 42.2297 50.1652 41.7449C50.6515 41.2601 50.945 40.615 50.9909 39.9299C50.9976 39.8315 50.9976 39.7265 50.9976 39.6299V33.3699C50.9976 33.2732 50.9976 33.1682 50.9909 33.0699C50.9451 32.385 50.6518 31.7401 50.1658 31.2554C49.6799 30.7706 49.0343 30.479 48.3493 30.4349M43.6443 38.1199C44.4993 38.1199 45.1943 37.3965 45.1943 36.5015C45.1943 35.6065 44.4993 34.8832 43.6443 34.8832C42.7893 34.8832 42.0959 35.6065 42.0959 36.5015C42.0959 37.3965 42.7876 38.1199 43.6443 38.1199Z"
                                        fill="black"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M48.056 45.0007C48.1119 44.9987 48.1674 45.0099 48.2181 45.0333C48.2688 45.0567 48.3133 45.0918 48.348 45.1356C48.3827 45.1793 48.4067 45.2307 48.4179 45.2854C48.4291 45.3401 48.4273 45.3967 48.4127 45.4507C48.0893 46.604 47.5777 47.5873 46.756 48.414C45.5543 49.6257 44.0293 50.164 42.146 50.419C40.316 50.6673 37.9793 50.6673 35.026 50.6673H31.631C28.6793 50.6673 26.341 50.6673 24.511 50.419C22.6277 50.164 21.1027 49.6257 19.901 48.414C18.6993 47.2057 18.166 45.6673 17.9127 43.7707C17.666 41.924 17.666 39.5673 17.666 36.5923V36.409C17.666 33.434 17.666 31.0757 17.9127 29.2323C18.166 27.334 18.6993 25.8007 19.8993 24.5857C21.101 23.3757 22.626 22.8357 24.5093 22.5823C26.341 22.334 28.6793 22.334 31.631 22.334H35.026C37.9777 22.334 40.316 22.334 42.146 22.5823C44.0293 22.8373 45.5543 23.3757 46.756 24.5857C47.5777 25.414 48.0893 26.3973 48.4127 27.5523C48.427 27.6061 48.4286 27.6625 48.4172 27.7171C48.4058 27.7716 48.3818 27.8227 48.3472 27.8662C48.3125 27.9098 48.2681 27.9447 48.2176 27.968C48.167 27.9914 48.1117 28.0025 48.056 28.0007H44.001C39.4443 28.0007 35.4293 31.629 35.4293 36.5007C35.4293 41.3723 39.446 45.0007 44.0027 45.0007H48.056ZM23.6893 28.8107C23.5307 28.8113 23.3737 28.8432 23.2273 28.9045C23.081 28.9659 22.9481 29.0554 22.8364 29.1681C22.7246 29.2808 22.6362 29.4143 22.5761 29.5612C22.516 29.708 22.4854 29.8653 22.486 30.024C22.486 30.6957 23.0243 31.239 23.6893 31.239H30.116C30.7827 31.239 31.321 30.6957 31.321 30.024C31.3219 29.7034 31.1955 29.3955 30.9696 29.168C30.7436 28.9405 30.4366 28.812 30.116 28.8107H23.6893Z"
                                        fill="black"
                                    />
                                    <path
                                        d="M27.2949 20.7063L30.5583 18.3013C31.4098 17.6718 32.4409 17.332 33.4999 17.332C34.5589 17.332 35.59 17.6718 36.4416 18.3013L39.7233 20.7197C38.3499 20.6663 36.8166 20.6663 35.1383 20.6663H31.5216C29.9849 20.6663 28.5733 20.6663 27.2949 20.7063Z"
                                        fill="black"
                                    />
                                </svg>
                            </div>
                            <div className="box px-2 my-auto">
                                <div className="text-box">
                                    <p className="mb-1">Total Earnings</p>
                                    <span className="head-box-count">${totalEarnings}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mstatus mt-3">
                    <Mstatus />
                </div>
                <div className="charts-menu mt-3">
                    <div className="row">
                        <div className="col-md-12 col-lg-6 mb-2 mb-lg-0 px-1">
                            <div className="card m-wrapper">
                                <div className="card-body">
                                    <div className="card-title">
                                        <h4> Payout Overview</h4>
                                    </div>
                                    <ChartsDashboard />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-6 mb-2 mb-lg-0 px-1">
                            <div className="card m-wrapper" style={{ height: "576px" }}>
                                <div className="card-body">
                                    <AreaChart />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <style jsx>
                {`
                    .sidebar {
                        color: #000;
                        flex-shrink: 0;
                        padding: 16px 0;
                    }

                    .dropdown-item.active,
                    .dropdown-item:active {
                        background-color: #e1e1e1 !important;
                        color: #fff;
                    }
                    li.sidebar-item:active {
                        background-color: #000;
                        color: #fff;
                    }

                    li.sidebar-item {
                        padding: 12px;
                        cursor: pointer;
                        width: 100%;
                    }

                    li.sidebar-item:hover {
                        background-color: #000000;
                        color: #fff !important;
                        border-radius: 10px;
                        transition: 0.3s all ease;
                    }
                    .menu-icon svg,
                    .sidebar nav ul li svg {
                        fill: #1c1c1c;
                    }

                    .content-container {
                        width: 100%;
                    }

                    .routes span {
                        font-size: 14px;
                        font-weight: 500;
                    }
                    .MuiChartsLegend-mark {
                        display: none;
                    }

                    .addmember-btn {
                        width: 210px;
                        height: 48px;
                        font-size: 18px;
                    }
                    .sidebar-dropdown {
                        cursor: pointer;
                        width: 100%;
                    }
                    .sidebar-dropdown > .item {
                        padding: 12px;
                    }
                    li.sidebar-dropdown:hover > .item {
                        background-color: #000000;
                        color: #fff !important;
                        border-radius: 10px;
                        transition: 0.3s all ease;
                    }
                    .sidebar nav ul.submenu {
                        list-style: disc !important;
                        padding: 0px 24px !important;
                        flex-direction: column !important;
                    }
                    .sidebar nav ul.submenu li.active {
                        font-weight: 600;
                    }
                    .text-dark > span {
                        cursor: pointer;
                    }
                    .sidebar-item,
                    .sidebar-dropdown {
                        width: unset !important;
                    }
                    li.nav-item .nav-link {
                        font-weight: 500;
                    }

                    .nav {
                        gap: 28px;
                        padding: 0px 18px;
                    }
                    .nav-link span {
                        position: relative;
                    }
                    .nav-link.active span::before {
                        content: "";
                        height: 2px;
                        width: 100%;
                        background-color: #1c1c1c;
                        position: absolute;
                        bottom: -12px;
                        right: 0;
                    }
                    .nav-link {
                        padding-right: 0px;
                        padding-left: 0px;
                    }
                `}
            </style>
        </section>
    );
};

export default Dashboard;
